import EditPaymentMethod from './EditPaymentMethod';

export default EditPaymentMethod;
